export var CHANNEL_TYPE_ENUM;
(function(CHANNEL_TYPE_ENUM2) {
  CHANNEL_TYPE_ENUM2["MASTER"] = "MASTER";
  CHANNEL_TYPE_ENUM2["SHOPEE"] = "SHOPEE";
  CHANNEL_TYPE_ENUM2["TIKTOK"] = "TIKTOK";
})(CHANNEL_TYPE_ENUM || (CHANNEL_TYPE_ENUM = {}));
export const CLONE_PATH_ENUM = {
  [CHANNEL_TYPE_ENUM.MASTER]: "/saas/master-product/clone",
  [CHANNEL_TYPE_ENUM.SHOPEE]: "saas/product/batch_clone",
  [CHANNEL_TYPE_ENUM.TIKTOK]: "saas/product/batch_clone"
};
